
import { Link } from "react-router-dom";
import { Logo } from "@/components/ui/logo";
import { ExternalLink } from "lucide-react";

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full border-t bg-background py-12">
      <div className="container grid gap-8 md:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col gap-4">
          <Logo />
          <p className="text-sm text-muted-foreground max-w-xs">
            Empowering creators to build and sell online courses under their own brand.
          </p>
        </div>
        
        <div>
          <h4 className="text-sm font-semibold mb-4">Product</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Features
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/examples" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Examples
              </Link>
            </li>
          </ul>
        </div>
        
        <div>
          <h4 className="text-sm font-semibold mb-4">Resources</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Blog
              </Link>
            </li>
            <li>
              <Link to="/help" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Help Center
              </Link>
            </li>
            <li>
              <Link to="/creators" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Creator Stories
              </Link>
            </li>
          </ul>
        </div>
        
        <div>
          <h4 className="text-sm font-semibold mb-4">Company</h4>
          <ul className="space-y-3">
            <li>
              <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="container mt-12 pt-6 border-t">
        <div className="flex items-center justify-center">
          <p className="text-xs text-muted-foreground flex items-center">
            © {currentYear} Showee, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
